import { MenuModel } from "../menu.model";

export class MenuResponseModel {
    lstMenu : MenuModel[];
    lstSubMenu: MenuModel[];
    constructor() {
      this.lstMenu = [];
      this.lstSubMenu = [];
    }
  }
  